const truncate = (str, n) => {
    return str?.length > n ? str.substr(0, n - 1) + "..." : str;
  };

  const filterKey = (filterAllWebParts , key) => {
    if (filterAllWebParts) {
      const result = JSON.parse(filterAllWebParts[0]?.specification)?.filter(
        (item) => {
          return item.Key === key;
        }
      );
      return result;
    }
  };

  export { filterKey , truncate}